import React from 'react';
import { useParams } from 'react-router-dom';
import './ThankYouPage.css'; // Importar los estilos

const ThankYouPage = () => {
    const { orderNumber } = useParams(); 

    return (
        <div className="thank-you-page">
            <div className="thank-you-container">
                <h1 className="thank-you-title">¡Gracias por tu compra!</h1>
                <p className="thank-you-order">Tu número de pedido es: <strong>{orderNumber}</strong></p>
                <p className="thank-you-instructions">
                    Recuerda que después de confirmar tu compra, recibirás un email con el alias para
                    hacer la transferencia. Una vez confirmado el pago, te enviaremos un correo con la
                    preparación de tu pedido.
                </p>
            </div>
        </div>
    );
};

export default ThankYouPage;
